// Edit shift-start and shift-end checklists. Items stored as JSON
// [{id, label, required}, ...].

import { useEffect, useState } from 'react';
import { api } from '../../api';
import ModalRoot from '../../components/ModalRoot';

function nextId(items) {
  let i = 1; const used = new Set(items.map(x => x.id));
  while (used.has(`item_${i}`)) i++;
  return `item_${i}`;
}

export default function ChecklistTemplatesPage() {
  const [templates, setTemplates] = useState([]);
  const [err, setErr] = useState('');
  const [editing, setEditing] = useState(null);

  function load() {
    Promise.all([api.listChecklistTemplates('shift_start'), api.listChecklistTemplates('shift_end')])
      .then(([a, b]) => setTemplates([...a, ...b]))
      .catch(e => setErr(e.message));
  }
  useEffect(load, []);

  return (
    <div className="page">
      <div className="page-header"><h2>Shift Checklists</h2></div>
      {err && <div className="error-banner">{err}</div>}
      <table className="data-table">
        <thead><tr><th>Name</th><th>Scope</th><th>Region</th><th>Items</th><th>Active</th><th></th></tr></thead>
        <tbody>
          {templates.map(t => (
            <tr key={t.id}>
              <td>{t.name}</td>
              <td>{t.scope === 'shift_start' ? 'Start' : 'End'}</td>
              <td>{t.station_region || 'All'}</td>
              <td>{t.items?.length || 0}</td>
              <td>{t.is_active ? '✓' : '—'}</td>
              <td><button className="btn-secondary" onClick={() => setEditing(t)}>Edit</button></td>
            </tr>
          ))}
          {templates.length === 0 && <tr><td colSpan="6" className="empty">No templates yet.</td></tr>}
        </tbody>
      </table>
      {editing && (
        <ChecklistEditor template={editing} onClose={() => setEditing(null)} onDone={() => { setEditing(null); load(); }} />
      )}
    </div>
  );
}

function ChecklistEditor({ template, onClose, onDone }) {
  const [items, setItems] = useState(template.items || []);
  const [name, setName] = useState(template.name);
  const [region, setRegion] = useState(template.station_region || '');
  const [isActive, setIsActive] = useState(!!template.is_active);
  const [err, setErr] = useState('');

  function addItem() {
    setItems(xs => [...xs, { id: nextId(xs), label: '', required: false }]);
  }
  function updateItem(idx, k, v) {
    setItems(xs => xs.map((it, i) => i === idx ? { ...it, [k]: v } : it));
  }
  function removeItem(idx) {
    setItems(xs => xs.filter((_, i) => i !== idx));
  }
  async function save() {
    try {
      await api.updateChecklistTemplate(template.id, { name, station_region: region || null, is_active: isActive, items });
      onDone();
    } catch (e) { setErr(e.message); }
  }

  return (
    <ModalRoot onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-content modal-wide">
        <div className="modal-header"><h3>{template.scope === 'shift_start' ? 'Start' : 'End'} of Shift — {template.name}</h3><button className="modal-close" onClick={onClose}>&times;</button></div>
        <div className="modal-body">
          {err && <div className="form-error">{err}</div>}
          <div className="form-grid">
            <label>Name<input value={name} onChange={e => setName(e.target.value)} /></label>
            <label>Region (blank = all)<input value={region} onChange={e => setRegion(e.target.value)} placeholder="Fort Worth / Denton / …" /></label>
            <label><input type="checkbox" checked={isActive} onChange={e => setIsActive(e.target.checked)} /> Active</label>
          </div>
          <hr/>
          <h4>Items</h4>
          {items.map((it, idx) => (
            <div key={idx} className="checklist-editor-row">
              <input value={it.label} onChange={e => updateItem(idx, 'label', e.target.value)} placeholder="Item label" style={{ flex: 1 }} />
              <label><input type="checkbox" checked={!!it.required} onChange={e => updateItem(idx, 'required', e.target.checked)} /> Required</label>
              <button className="btn-secondary" onClick={() => removeItem(idx)}>×</button>
            </div>
          ))}
          <button className="btn-secondary" onClick={addItem}>+ Add Item</button>
          <div className="form-actions">
            <button className="btn-secondary" onClick={onClose}>Cancel</button>
            <button className="btn-primary" onClick={save}>Save</button>
          </div>
        </div>
      </div>
    </ModalRoot>
  );
}
